import { useState, useEffect } from 'react'
import { Slider } from '@/components/ui/slider'
import type { SliderPage } from '@/content/quiz/types'
import { SocialProofBlock } from './SocialProofBlock'

interface SliderQuestionProps {
  page: SliderPage
  value?: number
  onSelect: (value: number) => void
}

export function SliderQuestion({ page, value, onSelect }: SliderQuestionProps) {
  const [localValue, setLocalValue] = useState(value ?? page.min)

  useEffect(() => {
    if (value === undefined) {
      onSelect(page.min)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const step = page.step ?? 1

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-slate-900">{page.question}</h2>
      <div className="space-y-4">
        <div className="px-2">
          <Slider
            value={[localValue]}
            onValueChange={([v]) => {
              setLocalValue(v)
              onSelect(v)
            }}
            min={page.min}
            max={page.max}
            step={step}
          />
        </div>
        <div className="text-center">
          <span className="text-2xl font-semibold text-slate-900">
            {localValue}
            {page.unit && <span className="text-lg text-slate-600 ml-1">{page.unit}</span>}
          </span>
        </div>
      </div>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-8" />
      )}
    </div>
  )
}
